import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearError, getLoggedInUser } from "../../features/userSlice";
import { getAllPermissions } from "../../features/configSlice";
import Loading from "../loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../../pages/error/NetworkError";

const ProtectedRoute = ({ children, roles }) => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const loading = useSelector((state) => state.user.load.getLoggedInUser);
  const userPermissions = useSelector((state) => state.user.permissions);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  //Set Authorization to false initially
  let isAuthorized = false;

  //If permissions Array has values check if user is allowed on page
  if (userPermissions && userPermissions?.length > 0) {
    isAuthorized = userPermissions.some(
      (perm) => perm.action === roles.action && perm.resource === roles.resource
    );
  } else if (roles.action === "" && roles.resource === "") {
    isAuthorized = true;
  }

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
    } else if (token && !isAuthenticated) {
      dispatch(getLoggedInUser());
      dispatch(getAllPermissions());
    }
    return () => {
      dispatch(clearError());
    };
  }, []);

  //
  if (loading === loadStatus.loading) {
    return <Loading />;
  } else if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  } else if (token && !isAuthenticated) {
    return children;
  } else if (isAuthenticated && token && isAuthorized) {
    return children;
  } else if (isAuthenticated && token && !isAuthorized) {
    return <Navigate to="/not-authorized" replace={true} />;
  } else {
    return <Navigate to="/login" replace={true} />;
  }
};

export default ProtectedRoute;
